import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import { stageLabel } from "../lib/constants";
import { KanbanBoard } from "../components/KanbanBoard";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Kanban, ListBullets } from "@phosphor-icons/react";

export default function Pipeline() {
  const [view, setView] = useState("kanban");
  const { data: engagements } = useQuery({ queryKey: ["engagements"], queryFn: () => api.get("/engagements").then((r) => r.data) });

  return (
    <div className="p-8 space-y-6 fade-up" data-testid="pipeline-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-2xl font-medium tracking-tight text-zinc-900">Workflow Pipeline</h1>
          <p className="text-sm text-zinc-500 mt-1">Drag cards between stages · CPA gate on E-file & Accepted</p>
        </div>
        <div className="flex rounded-md border border-zinc-200 bg-white overflow-hidden">
          <button data-testid="view-kanban-btn" onClick={() => setView("kanban")} className={`px-3 py-1.5 text-xs flex items-center gap-1.5 transition-colors duration-150 ${view === "kanban" ? "bg-zinc-900 text-white" : "text-zinc-600 hover:bg-zinc-50"}`}><Kanban size={14} /> Board</button>
          <button data-testid="view-list-btn" onClick={() => setView("list")} className={`px-3 py-1.5 text-xs flex items-center gap-1.5 transition-colors duration-150 ${view === "list" ? "bg-zinc-900 text-white" : "text-zinc-600 hover:bg-zinc-50"}`}><ListBullets size={14} /> List</button>
        </div>
      </div>

      {view === "kanban" ? (
        <KanbanBoard engagements={engagements} />
      ) : (
        <div className="rounded-lg border border-zinc-200 bg-white overflow-hidden" data-testid="pipeline-list-view">
          <Table>
            <TableHeader>
              <TableRow className="bg-zinc-50">
                <TableHead className="text-xs">Client</TableHead>
                <TableHead className="text-xs">Service</TableHead>
                <TableHead className="text-xs">Year</TableHead>
                <TableHead className="text-xs">Stage</TableHead>
                <TableHead className="text-xs">Deadline</TableHead>
                <TableHead className="text-xs">Assigned</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {(engagements || []).map((e) => (
                <TableRow key={e.id} className="hover:bg-zinc-50 transition-colors duration-150">
                  <TableCell className="text-sm font-medium text-zinc-900">{e.client_name}</TableCell>
                  <TableCell className="text-sm text-zinc-600">{e.service_type}</TableCell>
                  <TableCell className="font-mono text-xs">{e.tax_year}</TableCell>
                  <TableCell><span className="text-xs bg-zinc-100 border border-zinc-200 rounded-sm px-1.5 py-0.5">{stageLabel(e.stage)}</span></TableCell>
                  <TableCell className="font-mono text-xs text-zinc-600">{e.deadline || "—"}</TableCell>
                  <TableCell className="text-xs text-zinc-500">{e.assigned_to || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
